import { Injectable } from '@angular/core';
import { BaseService, E8HttpClient, C8HttpClientOptions } from '../../../../core';
@Injectable()
export class DynamicComponentImportFormService extends BaseService {
  private getMetaInfo_URL = 'metabase/dynamicComponentImportForm/getMetaInfo';
  private downloadTemplate_URL = 'metabase/dynamicComponentImportForm/downloadTemplate';

  constructor(private client: E8HttpClient) {
    super();
  }

  // getMetaInfo(request: DynamicComponentGridFormGetMetaInfoRequest, options?: C8HttpClientOptions): Promise<DynamicComponentGridFormGetMetaInfoResponse> {
  //   return this.client.post(this.getMetaInfo_URL, request, options);
  // }

  downloadTemplate(urlParameter?: string) {
    return this.client.exportExcel(this.fUrl(this.downloadTemplate_URL+"?"+urlParameter), "");
  }
}
